import React, { useState } from 'react'
import {
    Container,
    Row,
    Col,
    Button,
    Spinner,
    CustomInput,
} from 'reactstrap'
import { AvForm, AvField } from 'availity-reactstrap-validation'
import { connect } from 'react-redux'
import { uploadRoom } from '../../../../redux/tools/actions'

import './uploadRoom.css'

const UploadRoom = (props) => {
    const [roomName, setRoomName] = useState(null)
    const [roomImage, setRoomImage] = useState(null)
    const [error, setError] = useState(null)

    const handleSubmit = (event, errors, values) => {
        event.preventDefault()
        event.persist()

        setError(errors)

        if (errors.length == 0) {
            props.uploadRoom(roomName, roomImage)
            props.onClose()
        }
    }

    const handleInputChange = (e) => {
        const name = e.target.name
        if (name === 'name') setRoomName(e.target.value)
    }

    const handleUpload = async (e) => {
        const file = e.target.files[0]
        setRoomImage(file)
    }

    return (
        <Container className="upload-room-container">
            <Row>
                <Col className="text-right">
                    <AvForm onSubmit={handleSubmit}>
                        <AvField
                            onChange={handleInputChange}
                            name="name"
                            bsSize="lg"
                            label="نام اتاق"
                            type="text"
                            validate={{
                                required: {
                                    value: true,
                                    errorMessage: 'فیلد الزامی است',
                                },
                            }}
                        />
                        <AvField
                            tag={CustomInput}
                            type="file"
                            name="file"
                            onChange={handleUpload}
                            label="فایل خود را انتخاب کنید"
                            validate={{
                                required: {
                                    value: true,
                                    errorMessage: 'هیچ فایلی انتخاب نشده است',
                                },
                            }}
                        />
                        <div className="text-center mt-3">
                            {!props.loading ? (
                                <Button type="submit" color="primary" size="lg">
                                    آپلود
                                </Button>
                            ) : (
                                <Spinner />
                            )}
                        </div>
                    </AvForm>
                </Col>
            </Row>
        </Container>
    )
}

const mapStateToProps = (state) => {
    return {
        loading: state.tools.loading,
        error: state.tools.error,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        uploadRoom: (name, file) => dispatch(uploadRoom(name, file)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(UploadRoom)
